import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Color } from '@sunrun/mui-theme';
import { H2_FONT_SIZE } from './constants/_sizes';

const StyledH2 = styled.h2`
  color: ${Color.BLACK_85};
  line-height: 46px;
  font-size: ${H2_FONT_SIZE};
  font-weight: bold;
  font-family: Roobert, sans-serif;
  margin: 0;
`;

const H2 = ({ children, ...props }) => <StyledH2 {...props}>{children}</StyledH2>;

H2.propTypes = {
  children: PropTypes.node.isRequired,
};

export default H2;
